import React, {
    useContext,
    useMemo,
    useEffect,
    useCallback,
    useState
} from 'react'
import { useForm } from 'react-hook-form'
import { ReportingContext } from '../../../wrappers/ReportingContext'
import LoadingSpinner from '../../../elem/LoadingSpinner'
import {
    defaultReportConfig,
} from '../../../../utils/reporting/config'
import EditReportLayout from '../../../elem/reporting/shared/EditReportLayout'
import ReportFormContextProvider from '../../../elem/reporting/shared/ReportFormContext'
import EditReportInformation from '../../../elem/reporting/shared/form/ReportInformation'
import CreateReport from '../../../elem/reporting/shared/form/CreateReport'
import Filters from '../../../elem/reporting/shared/form/Filters'
import Preview from '../../../elem/reporting/shared/form/Preview'
import Joins from '../../../elem/reporting/shared/form/Joins'
import TopBar from '../../../elem/reporting/TopBar'
import Sidebar from '../../../elem/reporting/shared/form/Sidebar'
import ReportEditorModal from '../../../elem/reporting/shared/form/ReportEditorModal'
import UnsavedChangesModal from '../../../elem/reporting/shared/form/UnsavedChangesModal'
import SelectColumns from '../../../elem/reporting/shared/form/select-columns/SelectColumns'
import GroupByColumns from '../../../elem/reporting/shared/form/groupby-columns/GroupByColumns'
import OrderByColumns from '../../../elem/reporting/shared/form/orderby-columns/OrderByColumns'

const ReportForm = () => {
    const { report, reportConfig, loading, saveReport, selectedFormSection } = useContext(ReportingContext)
    
    const initialValues = useMemo(() => {        
        if (report && reportConfig) {
            return {
                reportName: report && report.ReportName,
                reportDescription: report && report.ReportDescription,
                databaseName: report && report.DatabaseName,
                columns:
                    reportConfig && reportConfig.columns
                        ? reportConfig.columns
                        : [],
                filters:
                    reportConfig && reportConfig.filters
                        ? reportConfig.filters
                        : reportConfig.filters,
                primaryDataSourceName:
                    reportConfig && reportConfig.primaryDataSourceName,
                dataSources: [],
                dataSourceColumns: [],
                joins:
                    reportConfig && reportConfig.joins
                        ? reportConfig.joins
                        : [],
                tags:
                    reportConfig && reportConfig.tags
                        ? reportConfig.tags.map((x) => ({ label: x, value: x }))
                        : [],
                limit: reportConfig && reportConfig.limit,
                hasDistinct: reportConfig && reportConfig.hasDistinct,
                groupBy: reportConfig && reportConfig.groupBy,
                orderBy: reportConfig && reportConfig.orderBy,
                whereGroupsIncluded: reportConfig && reportConfig.whereGroupsIncluded,
            }
        } else {
            return defaultReportConfig
        }
    }, [reportConfig, report])

    const methods = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        // defaultValues: initialValues,
        // shouldUnregister: true
    })

    const {
        handleSubmit,
        setValue,
        getValues,
        reset,
    } = methods

    // when the initial values change (aka report or report config changed)
    // reset the form
    const updateForm = useCallback(
        (newValues) => {
            // set the field array values
            setValue('tags', newValues.tags)
            setValue('columns', newValues.columns)
            setValue('joins', newValues.joins)
            reset(newValues)
        },
        [setValue, reset, getValues]
    )

    useEffect(() => {
        updateForm(initialValues)
    }, [initialValues])

    const onSubmit = useCallback(
        (data) => {
            saveReport(data)
        },
        [saveReport]
    )

    return (
        <ReportFormContextProvider methods={methods}>
            <EditReportLayout>
                <form
                    id={'reportForm'}
                    name="reportForm"
                    className="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <TopBar />
                    {report && reportConfig && (
                        <div className="columns">
                            <div className="column is-10">
                                <div className="reportContainer">
                                    {selectedFormSection === "Create Report" ? <CreateReport /> : <EditReportInformation />}
                                    <Joins />
                                    <Filters />
                                    <SelectColumns />
                                    <GroupByColumns />
                                    <OrderByColumns />
                                    {/* <ConfigureColumns /> */}
                                    {/*<Summarize />*/}
                                    <Preview />
                                    {/* <div className="columns is-centered">
                                        <div className="column is-4 buttonWrapper"> 
                                            <SaveButton isSubmitting={isSubmitting} />
                                            <ResetButton onClick={() => resetForm()} />
                                            </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="column is-2">
                                <Sidebar />
                            </div>
                        </div>
                    )}
                </form>
            </EditReportLayout>
            {loading || !report || !reportConfig ? <LoadingSpinner size='6em' /> : null}
            <ReportEditorModal />
            <UnsavedChangesModal />
        </ReportFormContextProvider>
    )
}

export default ReportForm
